import React from "react";
import "./Label.scss";

export default function Label({ children, center, big }) {
  return <div className={"Label " + (center ? "center " : " ")+(big ? "big " : " ")}>{children}</div>;
}
